module.exports = __webpack_public_path__ + "static/media/Layout6.1dfd74da.png";